import * as types from '../types';
import { user } from '~api';

const {
  apiTest,
} = user;

export default {
  // 测试接口
  async serviceTest({ commit }, payload) {
    const resp = await apiTest(payload);
    if (resp.data) commit(types.SERVICE_TEST, resp.data);
  },
};
